import "core-js/modules/es.object.assign.js";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { getHtmlExcerpt } from '@finect/front-utils/getHtmlExcerpt';
import { DateLabel } from '../../../DateLabel';
import { Image } from '../../../Image';
import { getCommonsProps } from '../utils';
import { ArticleTitle, DateBlock, InnerBlock, BottomBlock, AspectRatioContainer, AspectRatioContent, ImageColumnBlock, ContentBlock, ArticleDescription, ImageFigure } from '../partials';
import { Author } from '../Author';
import { Tags } from '../Tags';
export var SmallArticleCard = function SmallArticleCard(props) {
  var article = props.article,
    _props$withDescriptio = props.withDescription,
    withDescription = _props$withDescriptio === void 0 ? false : _props$withDescriptio,
    _props$withImage = props.withImage,
    withImage = _props$withImage === void 0 ? false : _props$withImage,
    _props$withTags = props.withTags,
    withTags = _props$withTags === void 0 ? false : _props$withTags,
    _props$withAuthor = props.withAuthor,
    withAuthor = _props$withAuthor === void 0 ? true : _props$withAuthor,
    _props$withOrganizati = props.withOrganization,
    withOrganization = _props$withOrganizati === void 0 ? false : _props$withOrganizati,
    _props$withAuthorIcon = props.withAuthorIcon,
    withAuthorIcon = _props$withAuthorIcon === void 0 ? true : _props$withAuthorIcon,
    _props$authorBasic = props.authorBasic,
    authorBasic = _props$authorBasic === void 0 ? false : _props$authorBasic,
    _props$withDate = props.withDate,
    withDate = _props$withDate === void 0 ? true : _props$withDate,
    _props$imageFormat = props.imageFormat,
    imageFormat = _props$imageFormat === void 0 ? 'horizontal' : _props$imageFormat,
    imageLoading = props.imageLoading,
    _props$withAuthorImag = props.withAuthorImage,
    withAuthorImage = _props$withAuthorImag === void 0 ? false : _props$withAuthorImag,
    titleFontWeight = props.titleFontWeight,
    titleLineHeight = props.titleLineHeight,
    titleFontSize = props.titleFontSize,
    _props$onClick = props.onClick,
    onClick = _props$onClick === void 0 ? function () {} : _props$onClick,
    _props$compact = props.compact,
    compact = _props$compact === void 0 ? false : _props$compact;
  var _getCommonsProps = getCommonsProps(props),
    metaDescription = _getCommonsProps.metaDescription,
    displayTags = _getCommonsProps.displayTags,
    linkProps = _getCommonsProps.linkProps,
    imageUrl = _getCommonsProps.imageUrl,
    date = _getCommonsProps.date;
  var title = article.title,
    author = article.author;
  return React.createElement(InnerBlock, {
    $variantId: "small"
  }, withTags ? React.createElement(Tags, {
    tags: displayTags
  }) : null, React.createElement(ContentBlock, {
    withAuthorImage: withAuthorImage
  }, withImage && imageFormat === 'square' ? React.createElement(ImageColumnBlock, {
    $variantId: "small",
    imagePosition: "left",
    imageFormat: "square"
  }, React.createElement(ImageFigure, null, imageUrl ? React.createElement(Image, {
    src: imageUrl,
    height: 56,
    width: 56,
    loading: imageLoading
  }) : null)) : null, withImage && imageFormat === 'horizontal' ? React.createElement(ImageColumnBlock, {
    $variantId: "small",
    imagePosition: "left"
  }, React.createElement(AspectRatioContainer, null, React.createElement(AspectRatioContent, null, React.createElement(ImageFigure, null, imageUrl ? React.createElement(Image, {
    src: imageUrl,
    alt: title,
    height: 90,
    loading: imageLoading
  }) : null)))) : null, React.createElement("div", null, React.createElement(ArticleTitle, _extends({
    $compact: compact,
    onClick: onClick,
    $variantId: "small",
    $fontWeight: titleFontWeight,
    $lineHeight: titleLineHeight,
    $fontSize: titleFontSize
  }, linkProps), title), React.createElement(BottomBlock, {
    withAuthor: withAuthor && author
  }, withAuthor && author ? React.createElement(Author, {
    author: author,
    basic: authorBasic,
    withIcon: withAuthorIcon && !withAuthorImage,
    withOrganization: withOrganization
  }) : null, withDate && date ? React.createElement(DateBlock, null, React.createElement(DateLabel, {
    date: new Date(date),
    format: "timeSince"
  })) : null), withDescription && metaDescription ? React.createElement(ArticleDescription, {
    $variantId: "small"
  }, getHtmlExcerpt(metaDescription, 88)) : null)));
};